import { Injectable } from '@angular/core';
import { Actions, Effect ,ofType} from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { tap, switchMap, map, catchError } from 'rxjs/operators';
import * as PerfilInicActions from '../../actions/';
import { PerfilInicio } from 'src/app/models/SicarMap/perfilInicio.model';
import { PerfilService } from 'src/app/services/SicarMap/Perfil.service';


@Injectable()
export class perfilInicEffects {

    constructor(
    private actions: Actions,
    private PerfilService: PerfilService,
    private router: Router
    ) {}

    @Effect()
    GetPerfilIni: Observable<any> = this.actions.pipe(
        ofType(PerfilInicActions.PerfilIniActionTypes.GET_PERFIL_INI),
          switchMap((action: PerfilInicActions.GetPerfilIni) => {
                return this.PerfilService.getConfigPerfil(action.IdUsuario, action.IdPerfil)
                    .pipe(
                        map((Datos: PerfilInicio) => {
                            this.PerfilService.IdPerfil = Datos.id;
                            return new PerfilInicActions.GetPerfilIniSuccess(Datos)
                        }),
                        catchError(error => of (new PerfilInicActions.GetPerfilIniFailure({ error: error })))
                    );
      }));
}
